import React, { useEffect, useRef, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux'
import { history } from '../../history';
import { AppHeader } from '../../components/common/LeftMenu';
import { Html5Qrcode, Html5QrcodeScannerState } from 'html5-qrcode';
import { Translate as t } from '../../config/Translate';

// BUG fix: react-qr-reader@2.2.1 은 Android 다중 후면 카메라(Galaxy S22 등)에서
// 부적합한 센서를 선택해 디코드 실패. html5-qrcode 로 교체.
const QR_REGION_ID = 'qr-reader-region';

const QRScan = ({ }) => {

	const user = useSelector((state) => state.AuthReducer.user)
	// const [ t, i18n ] = useTranslation();
	const [qrStart, setQRStart] = useState(false);
	const [err, setErr] = useState("");
	const scannerRef = useRef(null);
	const isCameraSupported = !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);

	const handleScan = data => {
		if (!data) return;
		const arr = data.split('=');
		// 'prefix=SN' 형식이면 SN, 아니면 원문 사용 — /Product/undefined 방지
		const sn = (arr.length > 1 ? arr[1] : arr[0]).trim();
		if (sn) {
			history.push("/Product/" + sn);
		}
	}

	const stopScanner = () => {
		const scanner = scannerRef.current;
		scannerRef.current = null;
		if (scanner && scanner.getState && scanner.getState() === Html5QrcodeScannerState.SCANNING) {
			scanner.stop().then(() => scanner.clear()).catch(() => { });
		}
	}

	useEffect(() => {
		if (!qrStart || !isCameraSupported) {
			return undefined;
		}
		setErr("");
		const scanner = new Html5Qrcode(QR_REGION_ID);
		scannerRef.current = scanner;
		let handled = false;
		let cancelled = false;
		scanner.start(
			{ facingMode: "environment" },
			{ fps: 10, qrbox: { width: 250, height: 250 } },
			(decodedText) => {
				if (handled) return;
				handled = true;
				handleScan(decodedText);
				stopScanner();
			},
			() => { /* 프레임별 디코드 미스: 정상 동작, 무시 (토스트 노이즈 방지) */ }
		).then(() => {
			// start() resolve 전 cleanup 이 실행된 경우(race):
			// cleanup 이 scannerRef.current=null 로 비웠으므로 stopScanner() 는 no-op.
			// 클로저 scanner 를 직접 참조하여 SCANNING 상태면 자원 해제.
			if (cancelled && scanner.getState && scanner.getState() === Html5QrcodeScannerState.SCANNING) {
				scanner.stop().then(() => scanner.clear()).catch(() => {});
			}
		}).catch((e) => {
			// 카메라 시작 실패(권한 거부 / 카메라 없음 / 미지원) — silent-drop 금지
			console.warn('[QRScan] camera start failed', { handler: 'QRScan', reason: (e && e.message) || String(e) });
			setErr(t('scan.camera.startFailed'));
		});
		return () => {
			cancelled = true;
			stopScanner();
		};
	}, [qrStart, isCameraSupported]);

	return (
		<>
			<div className="appHeader no-border">
				<AppHeader title={t('scan.button.scanQrCode')} />
				<div className="right">
				</div>
			</div>
			<div id="appCapsule" className={!qrStart ? "extra-header-active full-height" : "full-height"}>
				{!qrStart &&
					<>
						<div className="section">
							<div className="splash-page mt-5 mb-5">
								<div className="mb-3">
									<img src="assets/img/qrcode-quide-ct.png" alt="QR Code" className="imaged square w310" />
								</div>
								{t('scan.message.pleaseScanTheQr')}
							</div>
						</div>
						<div className="section">
							<div className="fixed-bar b60">
								<button className="btn btn-lg btn-primary mb-2 btn-block" onClick={() => setQRStart(true)}>{t('scan.button.scanQrCode')}</button>
							</div>
						</div>
					</>
				}
				{qrStart &&
					<div className="section ps-2 pe-2">
						{isCameraSupported ? (
							<div id={QR_REGION_ID} style={{ width: '100%' }} />
						) : (
							<div className="alert alert-warning">{t('scan.camera.notSupported')}</div>
						)}
						{err && <p className="alert alert-danger">{err}</p>}
						<button className="btn btn-lg btn-dark mt-2 mb-2 btn-block" onClick={() => setQRStart(false)}>{t('common.button.cancel')}</button>
					</div>
				}
			</div>
		</>
	)
}

export default QRScan;
